module.exports = __webpack_public_path__ + "img/members-icon-active.33f4c316.svg";